import { useAccount, useConnect, useDisconnect } from "wagmi";

export function useWallet() {
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const { connectors, connect, isPending, isError, isSuccess } = useConnect();

  const truncateAddress = (addr: string) => {
    return addr.slice(0, 6) + "..." + addr.slice(-4);
  };

  return {
    address,
    isConnected,
    disconnect,
    truncateAddress,
    connectors,
    connect,
    isPending,
    isError,
    isSuccess,
  };
}
